// extracted by mini-css-extract-plugin
export default {"block-container":"styles_block-container__LmDlk","title":"styles_title__v4KmR","label":"styles_label__g1zkE"};